<template>
  <section>
    <section class="grid-flex column margin-top-s">
      <!-- filters -->
      <div class="flex-1 w100">
        <div class="flex">
          <tabs :data="reportTabs" v-model="currentTab"></tabs>
        </div>
      </div>
    </section>

    <conversion-whats v-if="currentTab === 'conversion-whats'"></conversion-whats>
    <!-- encurtador de link -->
    <short-link v-if="currentTab === 'short-link-whats'"></short-link>
    <!-- whatspp -->
    <whats-app v-if="currentTab === 'whatsapp'"></whats-app>
  </section>
</template>

<script>
import Tabs from "@/components/tabs/Tabs";

import ShortLink from "@/modules/shortLink/ShortLink";
import WhatsApp from "@/modules/config/integrations/WhatsApp";
import ConversionWhats from "@/modules/config/integrations/ConversionWhats";

export default {
  name: "dash-detail",
  components: {
    Tabs,
    ShortLink,
    WhatsApp,
    ConversionWhats
  },
  props: [],
  data() {
    return {
      loading: false,
      currentTab: "whatsapp",
      reportTabs: [
        {
          name: "whatsapp",
          title: "Números de WhatsApps",
        },
        // {
        //   name: "short-link-whats",
        //   title: "Links Rastreaveis (WhatsApps)",
        // },
        {
          name: "conversion-whats",
          title: "Mensagens de Conversão",
        },
      ],
    };
  },
  mounted() {
  },
  watch: {
    currentTab() {
      if (this.slug === this.currentTab) {
        return
      }
      //this.$router.push({ name: "Track", params: { slug: this.currentTab } });
    }
  }

};
</script>

<style lang="scss" scoped></style>
